import { APP_INITIALIZER, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginRootComponent } from './login/feature/loginRoot.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { LoginFormComponent } from './login/feature/loginForm/loginForm.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginTermsComponent } from './login/feature/loginTerms/loginTerms.component';
import { LoginResearchComponent } from './login/feature/loginResearch/loginResearch.component';
import { StudentDashboardComponent } from './dashboard/feature/studentDashboard/studentDashboard.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DashboardWrapperComponent } from './dashboard/ui/dashboard-wrapper/dashboard-wrapper.component';
import { UserManagementListComponent } from './admin/feature/userManagement/userManagementList/userManagementList.component';
import { UserManagementMenuComponent } from './admin/feature/userManagement/userManagementMenu.component'
import { AgreementManagementList } from './admin/feature/agreement/agreementManagementList/agreementManagementList.component';
import { TokenInjectorInterceptor } from './shared/utils/token-injector.interceptor';
import { CreateEditAgreement } from './admin/feature/agreement/createEditAgreement/createEditAgreement.component'
import { AgreementPreview } from "./admin/feature/agreement/agreementPreview/agreementPreview.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { UserProfileComponent } from "./dashboard/userProfile/userProfile.component";
import {
  AgreementResponseList
} from "./admin/feature/agreement/agreementResponseList/agreementResponseList.component";
import { InstructorDashboardComponent } from './dashboard/feature/instructorDashboard/instructorDashboard.component';
import { DialogModule } from '@angular/cdk/dialog';
import { AuthService, authFactory } from './login/data-access/auth.service';
import { TooltipDirective } from "./shared/ui/tooltip/tooltip.component";
import { UserRolesListComponent } from "./admin/feature/userManagement/userRolesList/userRolesList.component";
import { UserRoleAddEditComponent } from "./admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.component";
import { ChipComponent } from "./shared/ui/chip/chip.component";
import { AddNewUserComponent } from "./admin/feature/userManagement/addNewUser/addNewUser.component";
import { BreadcrumbComponent } from "./shared/ui/breadcrumb/breadcrumb.component";
import { ImportUsersComponent } from "./admin/feature/userManagement/importUsers/importUsers.component";
import { RoleAssigneesComponent } from "./admin/feature/userManagement/roleAssignees/roleAssignees.component";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { SavePopupComponent } from "./shared/ui/save-popup/save-popup.component";
import { AutoImportUsersComponent } from "./admin/feature/userManagement/autoImportUsers/autoImportUsers.component";
import { AutoImportLogComponent } from "./admin/feature/userManagement/autoImportLog/autoImportLog.component";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OutlineButtonComponent } from "./shared/ui/outline-button/outline-button.component";
import { FullButtonComponent } from "./shared/ui/full-button/full-button.component";
import { ErrorDialogComponent } from "./shared/ui/error-dialog/error-dialog.component";
import { SubjectListComponent } from "./admin/feature/contentViewer/subjectList/subjectList.component";
import { LearningObjectiveList } from "./admin/feature/contentViewer/learningObjective/learningObjective.component";
import { CCLTreeComponent } from "./admin/feature/contentViewer/cclTree/cclTree.component";
import { ProblemTemplateList } from "./admin/feature/contentViewer/problemTemplateList/problemTemplateList.component";
import {
  ProblemTemplatePreview
} from "./admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import { DropdownMenuComponent } from "./shared/ui/dropdown-menu/dropdown-menu.component";
import { DrawableCanvasComponent } from "./shared/ui/drawable-canvas/drawable-canvas.component";
import "froala-editor/js/plugins.pkgd.min.js";
import { SubsectionsListComponent } from "./admin/feature/subsections/subsections-list/subsections-list.component";
import { SubsectionsStudentsComponent } from "./admin/feature/subsections/subsections-students/subsections-students.component";

/*declare const require: any;
(window as any).FroalaEditor = require("froala-editor");
require("@wiris/mathtype-froala3");*/

import {
  FroalaEditorModule,
  FroalaViewModule,
} from "angular-froala-wysiwyg";
import { MultipleChoiceComponent } from "./shared/ui/problem-templates/multiplechoice/multiplechoice.component";
import { DecimalComponent } from "./shared/ui/problem-templates/decimal/decimal.component";
import { GroupingComponent } from "./shared/ui/problem-templates/grouping/grouping.component";
import { TextareaComponent } from "./shared/ui/problem-templates/textarea/textarea.component";
import { AudioPlaybackComponent } from "./shared/ui/problem-templates/audio-playback/audio-playback.component";
import { FileUploadComponent } from "./shared/ui/problem-templates/file-upload/file-upload.component";
import { AudioRecordComponent } from "./shared/ui/problem-templates/audio-record/audio-record.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { AutoImportUsersConfigListComponent } from './admin/feature/userManagement/autoImportUsersConfigList/AutoImportUsersConfigListComponent';
import { NgOptimizedImage } from "@angular/common";
import { DashboardService } from "./shared/utils/dashboard-service";
import { DropdownSearchComponent } from './shared/ui/dropdown-search/dropdown-search.component';
import { SystemConfigComponent } from "./admin/feature/system-management/system-config/system-config.component";
import { SystemManagementMenuComponent } from "./admin/feature/system-management/system-management-menu.component";
import {
  OrganizationListComponent
} from "./admin/feature/system-management/organization-list/organization-list.component";
import { UnitListComponent } from "./admin/feature/system-management/units-list/unit-list.component";
import { CourseListComponent } from "./admin/feature/system-management/courses-list/course-list.component";
import { SystemSubjectListComponent } from "./admin/feature/system-management/subjects-list/subject-list.component";
import { SystemBrandingComponent } from "./admin/feature/system-management/system-branding/system-branding.component";
import { ClearButtonComponent } from "./shared/ui/clear-button/clear-button.component";
import {
  AnnouncementConfigComponent
} from "./admin/feature/system-management/announcement-config/announcement-config.component";
import {
  AnnouncementListComponent
} from "./admin/feature/system-management/announcement-list/announcement-list.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { MultifieldComponent } from "./shared/ui/problem-templates/multifield/multifield.component";
import { SystemListHubComponent } from "./admin/feature/system-management/system-list-hub/system-list-hub.component";
import { FormulaComponent } from "./shared/ui/problem-templates/formula/formula.component";
import { ForbiddenErrorComponent } from "./shared/ui/forbiddenError/forbidden-error.component";
import { SystemLogListComponent } from "./admin/feature/system-management/system-log-list/system-log-list.component";
import { MathjaxModule } from "mathjax-angular"
import { MonacoEditorModule } from "ngx-monaco-editor-v2";
import { CodeEditorComponent } from "./shared/ui/code-editor/code-editor.component";
import { CodeOutputComponent } from "./shared/ui/code-output/code-output.component";
import { ServerErrorComponent } from "./login/feature/server-error/server-error.component";
import { SearchInputComponent } from "./shared/ui/search-input/search-input.component";
import {
  StudentClassroomDashboardComponent
} from "./dashboard/feature/studentClassroomDashboard/studentClassroomDashboard.component";
import { CalendarComponent } from "./shared/ui/calendar/calendar.component";
import {
  StudentClassroomAssessmentsComponent
} from "./student-classroom/assessments/student-classroom-assessments.component";
import { ExamStatusComponent } from "./shared/ui/exam-status/exam-status.component";
import { StudentGradebookComponent } from "./student-classroom/gradebook/student-gradebook.component";
import {
  FullLengthPaginationComponent
} from "./shared/ui/pagination/full-length-pagination/full-length-pagination.component";
import { CheckboxCircleComponent } from "./shared/ui/icons/checkbox-circle/checkbox-circle.component";
import { QuillModule } from 'ngx-quill'
import { ClickOutsideDirective } from "./shared/utils/click-outside.directive";
import { InteractiveCalendarComponent } from "./shared/ui/interactive-calendar/interactive-calendar.component";
import { DeleteConfirmationComponent } from "./shared/ui/delete-confirmation/delete-confirmation.component";
import { DotSpinnerComponent } from "./shared/ui/loaders/dot-spinner.component";
import { PerPagePaginationComponent } from 'src/app/shared/ui/pagination/per-page-pagination/per-page-pagination.component';
import { SearchBarComponent } from 'src/app/shared/ui/search-bar/search-bar.component';
import {NanobarComponent} from "./shared/ui/nanobar/nanobar.component";
import { withInterceptors } from '@angular/common/http';
import { nanobarInterceptor } from "./shared/ui/nanobar/nanobar.interceptor";

@NgModule({
  declarations: [
    AppComponent,
    LoginRootComponent,
    LoginFormComponent,
    LoginTermsComponent,
    LoginResearchComponent,
    StudentDashboardComponent,
    StudentClassroomDashboardComponent,
    InstructorDashboardComponent,
    DashboardWrapperComponent,
    UserManagementListComponent,
    AgreementManagementList,
    CreateEditAgreement,
    AgreementPreview,
    UserProfileComponent,
    AgreementResponseList,
    UserManagementMenuComponent,
    UserRolesListComponent,
    UserRoleAddEditComponent,
    AddNewUserComponent,
    ImportUsersComponent,
    RoleAssigneesComponent,
    AutoImportUsersComponent,
    AutoImportLogComponent,
    SubjectListComponent,
    LearningObjectiveList,
    CCLTreeComponent,
    ProblemTemplateList,
    ProblemTemplatePreview,
    AutoImportUsersConfigListComponent,
    SystemConfigComponent,
    SystemManagementMenuComponent,
    OrganizationListComponent,
    SystemSubjectListComponent,
    UnitListComponent,
    CourseListComponent,
    SystemBrandingComponent,
    AnnouncementConfigComponent,
    AnnouncementListComponent,
    SystemListHubComponent,
    SystemLogListComponent,
    ServerErrorComponent,
    StudentClassroomAssessmentsComponent,
    StudentGradebookComponent,
    SubsectionsListComponent,
    SubsectionsStudentsComponent
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    FontAwesomeModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatMenuModule,
    MatTooltipModule,
    MatIconModule,
    MatSidenavModule,
    DialogModule,
    TooltipDirective,
    DropdownSearchComponent,
    ChipComponent,
    BreadcrumbComponent,
    FormsModule,
    MatSnackBarModule,
    SavePopupComponent,
    MatSlideToggleModule,
    OutlineButtonComponent,
    FullButtonComponent,
    ErrorDialogComponent,
    DropdownMenuComponent,
    DrawableCanvasComponent,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    MathjaxModule.forRoot({
      config: {
        loader: {load: ['[tex]/ams']},
        tex: {packages: {'[+]': ['ams']}},
      },
      src: 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js'
    }),
    MultipleChoiceComponent,
    DecimalComponent,
    GroupingComponent,
    TextareaComponent,
    AudioPlaybackComponent,
    FileUploadComponent,
    AudioRecordComponent,
    MatProgressBarModule,
    NgOptimizedImage,
    ClearButtonComponent,
    MatExpansionModule,
    MultifieldComponent,
    FormulaComponent,
    TooltipDirective,
    ForbiddenErrorComponent,
    CodeOutputComponent,
    CodeEditorComponent,
    SearchInputComponent,
    MonacoEditorModule.forRoot(),
    CalendarComponent,
    InteractiveCalendarComponent,
    DotSpinnerComponent,
    NanobarComponent,
    ExamStatusComponent, FullLengthPaginationComponent, CheckboxCircleComponent,
    QuillModule.forRoot(), ClickOutsideDirective, DeleteConfirmationComponent, DotSpinnerComponent, DatePipe, PerPagePaginationComponent, SearchBarComponent, NanobarComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: authFactory,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInjectorInterceptor,
      multi: true,
    },
    DashboardService,
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(withInterceptors([nanobarInterceptor])),
  ]
})
export class AppModule { }
